export class CuentaOrdenante {
    ORIGINATOR_BACK_ACCOUNT_ID?: number;
    NAME: string;
    ACCOUNT: string;
    RFC: string;
    CUSTOMER_ID: number;
    IS_FOREIGN: boolean;
    BANK_NAME: string;
    loacs: string;
    BANK_ID: number;
}


// WEBPACK FOOTER //
// ./src/app/models/cuenta-ordenante.ts